import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    timeout: any

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return new Promise((resolve) => {

            this.authService.isAdmin$.subscribe(res => {
                clearTimeout(this.timeout);
                if (res != null) {
                    if (!res) {
                        this.router.navigate(['/cms-login']);
                    }
                    resolve(res)
                }
                else {
                    this.timeout = setTimeout(() => {
                        
                        this.router.navigate(['/cms-login']);
                    }, 2000);
                }
            })

        })
    }

}
